"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = exports.InstanceFooter = void 0;
// @ts-nocheck
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const react_1 = __importStar(require("react"));
const FormRendererHelpers_1 = require("../../utils/FormRendererHelpers");
const RepeatWrapper_1 = require("./RepeatWrapper");
const RepeatFieldWrapper = (props) => {
    const { controlDefinition, onRemoveClick, repeatCount, isOriginal } = props;
    const { openDeleteConfirmation } = RepeatWrapper_1.useRepeatContext();
    const classes = exports.useStyles();
    const canDelete = react_1.useCallback(() => {
        if (isOriginal && !FormRendererHelpers_1.getAllowInitialDataDelete(controlDefinition)) {
            return false;
        }
        return repeatCount > FormRendererHelpers_1.getRepeatMin(controlDefinition);
    }, [repeatCount, controlDefinition, isOriginal]);
    return (react_1.default.createElement("div", { style: { flexDirection: 'column' } },
        react_1.default.createElement("div", { className: classes.fieldWrapper },
            props.children,
            canDelete() && (react_1.default.createElement(core_1.Button, { size: 'small', style: { color: '#EB5757', height: 50 }, variant: 'text', onClick: () => {
                    openDeleteConfirmation(onRemoveClick, FormRendererHelpers_1.getDeleteConfirmationMessage(controlDefinition));
                } }, "Delete"))),
        react_1.default.createElement(exports.InstanceFooter, Object.assign({}, props))));
};
const InstanceFooter = (props) => {
    const { repeatCount, index, controlDefinition, onAddClick } = props;
    const classes = exports.useStyles();
    const canDelete = react_1.useCallback(() => {
        return repeatCount === index + 1 && FormRendererHelpers_1.getRepeatsEnabled(controlDefinition);
    }, [repeatCount, index, controlDefinition]);
    const repeatMax = react_1.useMemo(() => {
        return FormRendererHelpers_1.getRepeatMax(controlDefinition);
    }, [controlDefinition]);
    const canAddItem = react_1.useCallback(() => {
        if (!FormRendererHelpers_1.getAllowAdding(controlDefinition)) {
            return false;
        }
        const repeatMaxSetting = FormRendererHelpers_1.getRepeatMax(controlDefinition);
        return repeatMaxSetting === -1 || repeatCount < repeatMaxSetting;
    }, [repeatCount, controlDefinition]);
    return canDelete() ? (react_1.default.createElement("div", { style: {
            backgroundColor: '#F8F8F8',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '6px 10px',
        } },
        react_1.default.createElement("div", { style: { display: 'flex', fontSize: '13px' } },
            react_1.default.createElement("span", { className: classes.instanceInfo }, "Instances "),
            ": ",
            repeatCount,
            "\u00A0\u00A0",
            react_1.default.createElement("span", { className: classes.instanceInfo }, "Required"),
            " : ",
            FormRendererHelpers_1.getRepeatMin(controlDefinition),
            "\u00A0\u00A0",
            react_1.default.createElement("span", { className: classes.instanceInfo }, "Allowed"),
            ": ",
            repeatMax === -1 ? 'unlimited' : `${repeatMax}`),
        canAddItem() && (react_1.default.createElement(core_1.Button, { size: 'small', onClick: () => {
                onAddClick();
            }, color: 'primary' }, FormRendererHelpers_1.getAddButtonText(controlDefinition))))) : null;
};
exports.InstanceFooter = InstanceFooter;
exports.useStyles = styles_1.makeStyles((theme) => ({
    fieldWrapper: {
        margin: theme.spacing(1),
        display: 'flex',
        flexDirection: 'row',
    },
    repeatDetails: {
        margin: theme.spacing(1),
        display: 'flex',
    },
    repeatMenu: {
        margin: theme.spacing(1),
        display: 'flex',
    },
    instanceInfo: {
        fontWeight: 500,
    },
    handle: {
        display: 'flex',
        width: 25,
        alignItems: 'center',
        '& img': {
            width: 13,
            height: 21,
            marginRight: '.3em',
        },
        '& span': {
            color: '#aaaaaa',
        },
    },
}));
exports.default = RepeatFieldWrapper;
//# sourceMappingURL=RepeatFieldWrapper.js.map